export default __webpack_public_path__ + "static/media/banner-processing.a7d678d7.png";